import { render, staticRenderFns } from "./Notice_TunaiPro.vue?vue&type=template&id=4ce5cf31&"
import script from "./Notice_TunaiPro.vue?vue&type=script&lang=js&"
export * from "./Notice_TunaiPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports